/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Welcome_Suggestion_Generate_ReportsInputs */



/**
* | output |
* | --- |
* | "Turn my meeting notes into a summary" |
*
* @param {Uno_Welcome_Suggestion_Generate_ReportsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_welcome_suggestion_generate_reports = /** @type {((inputs?: Uno_Welcome_Suggestion_Generate_ReportsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Welcome_Suggestion_Generate_ReportsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mach aus meinen Meeting-Notizen eine Zusammenfassung")
	return /** @type {LocalizedString} */ ("Turn my meeting notes into a summary")
});